import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.PROVIDER_DETAILS_VIEW}`,
            render: () => import("../../Pages/Core/Providers/Form/ProviderForm.svelte"),
            title: "Provider Details"
        },
        {
            layout: "null",
            path: `?action=${ACTIONS.PROVIDER_DETAILS_CREATE}`,
            render: () => import("../../Pages/Core/Providers/Form/ProviderForm.svelte"),
            title: "Add New Provider"
        }
    ]
};

export default routerConfig;

